export const isLocal = ["localhost", "127.0.0.1", ""].some(
  x => x === window.location.hostname
);
export const isDev = window.location.hostname.startsWith("mdd-dev");
export const isTest = window.location.hostname.startsWith("mdd-test");
